
import { ReactNode } from 'react';

interface CardProps {
  children: ReactNode;
  className?: string;
  variant?: 'default' | 'service';
}

export default function Card({ children, className = '', variant = 'default' }: CardProps) {
  const baseClasses = 'rounded-lg transition-all duration-300 cursor-pointer';
  
  const variantClasses = {
    default: 'bg-white shadow-lg hover:shadow-xl',
    service: 'bg-black border-2 border-yellow-400 hover:border-yellow-300 hover:shadow-lg hover:shadow-yellow-400/20 transform hover:scale-105'
  };
  
  return (
    <div className={`${baseClasses} ${variantClasses[variant]} ${className}`}>
      {children}
    </div>
  );
}
